import React from "react";

interface Props {
  color?: string;
}

const LoanDocumentsIcon: React.FC<Props> = ({ color = "currentColor" }) => (
  <>
    <path
      d="M7.5013 4.16406H5.83464C4.91416 4.16406 4.16797 4.91025 4.16797 5.83073V15.8307C4.16797 16.7512 4.91416 17.4974 5.83464 17.4974H14.168C15.0884 17.4974 15.8346 16.7512 15.8346 15.8307V5.83073C15.8346 4.91025 15.0884 4.16406 14.168 4.16406H12.5013"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5013 4.16406H5.83464C4.91416 4.16406 4.16797 4.91025 4.16797 5.83073V15.8307C4.16797 16.7512 4.91416 17.4974 5.83464 17.4974H14.168C15.0884 17.4974 15.8346 16.7512 15.8346 15.8307V5.83073C15.8346 4.91025 15.0884 4.16406 14.168 4.16406H12.5013"
      stroke="black"
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.1}
    />
    <rect
      x="7.5"
      y="2.5"
      width="5"
      height="3.33333"
      rx="1.66667"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="7.5"
      y="2.5"
      width="5"
      height="3.33333"
      rx="1.66667"
      stroke="black"
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.1}
    />
    <path
      d="M7.50039 10.0026H7.50872"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.50039 10.0026H7.50872"
      stroke="black"
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.1}
    />
    <path
      d="M10.832 10.0026H12.4987"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.832 10.0026H12.4987"
      stroke="black"
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.1}
    />
    <path
      d="M7.50039 13.3307H7.50872"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.50039 13.3307H7.50872"
      stroke="black"
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.1}
    />
    <path
      d="M10.832 13.3307H12.4987"
      stroke={color}
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.832 13.3307H12.4987"
      stroke="black"
      strokeWidth="2.1875"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.1}
    />
  </>
);

export default LoanDocumentsIcon;
